<template>
  <el-container id="root_container" style="padding: 0px;margin: 0px; overflow: hidden;">

    <el-header class="headerManu"><nav-header active-index="cc"></nav-header></el-header>


    <el-main id="router_view">
      <el-row>
        <!--左侧菜单-->
        <el-col  id="menu_container" :span="menuSpan">
          <ih-signal-vertical-tabs :mTabs="mTabs" @tabChanged="menuClicked" v-show="(activeIndex =='env' ||activeIndex =='pop'  )"></ih-signal-vertical-tabs>
          <el-menu
            ref="el_menu_cc"
            v-if="activeIndex =='cc'"
            id="climateMenu"
            style="width: 100%;"
            :default-active="default_activemenu_cc"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose">
            <el-submenu index="temperature" class="menuGroup_title">
              <template slot="title" style="background-color: red;"><span class="GS_menuItem">Temperature</span></template>
              <el-menu-item index="cc_tmean_mean" menuGroup="cc_temprature" @click="foldMenuClick"><span class="GS_menuItem">Mean</span></el-menu-item>
              <el-menu-item index="cc_tstd_var"  menuGroup="cc_temprature" @click="foldMenuClick"><span class="GS_menuItem">Variability</span></el-menu-item>
              <el-menu-item index="cc_txx_ext"  menuGroup="cc_temprature" @click="foldMenuClick"><span class="GS_menuItem">Extremes</span></el-menu-item>
            </el-submenu>
            <el-submenu index="precipitation" class="menuGroup_title">
              <template slot="title" style="background-color: red;"><span class="GS_menuItem">Precipitation</span></template>
              <el-menu-item index="cc_prcptot_mean"  menuGroup="cc_precipitation" @click="foldMenuClick"><span class="GS_menuItem">Mean</span></el-menu-item>
              <el-menu-item index="cc_prcptot_var"  menuGroup="cc_precipitation" @click="foldMenuClick"><span class="GS_menuItem">Variability</span></el-menu-item>
              <el-menu-item index="cc_prcptot_ext"  menuGroup="cc_precipitation" @click="foldMenuClick"><span class="GS_menuItem">Extremes</span></el-menu-item>
            </el-submenu>
            <el-submenu index="sfcwind" class="menuGroup_title">
              <template slot="title" style="background-color: red;"><span  class="GS_menuItem">Wind speed</span></template>
              <el-menu-item index="cc_sfcwind_mean"  menuGroup="cc_wind" @click="foldMenuClick"><span class="GS_menuItem">Mean</span></el-menu-item>
              <el-menu-item index="cc_sfcwind_var"  menuGroup="cc_wind" @click="foldMenuClick"><span class="GS_menuItem">Variability</span></el-menu-item>
              <el-menu-item index="cc_sfcwindmax_ext"  menuGroup="cc_wind" @click="foldMenuClick"><span class="GS_menuItem">Extremes</span></el-menu-item>
            </el-submenu>
          </el-menu>

          <el-menu
            id="ChangeRisksMenus"
            v-show="activeIndex=='risk'"
            default-active="1"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose">
<!--            <el-submenu index="1" class="menuGroup_title">-->
<!--              <template slot="title" style="background-color: red;"><span>Population Risks</span></template>-->
<!--              <el-menu-item index="1-1" @click="foldMenuClick">Heatwave</el-menu-item>-->
<!--              <el-menu-item index="1-2" @click="foldMenuClick">Flood</el-menu-item>-->
<!--            </el-submenu>-->
<!--            <el-submenu index="2" class="menuGroup_title">-->
<!--              <template slot="title" style="background-color: red;"><span>Crop Yield Risks</span></template>-->
<!--              <el-menu-item index="2-1" @click="foldMenuClick">Rice</el-menu-item>-->
<!--              <el-menu-item index="2-2" @click="foldMenuClick">Wheat</el-menu-item>-->
<!--              <el-menu-item index="2-2" @click="foldMenuClick">Maize</el-menu-item>-->
<!--            </el-submenu>-->
<!--            <el-submenu index="3" class="menuGroup_title">-->
<!--              <template slot="title" style="background-color: red;"><span>GDP Loss Risks</span></template>-->
<!--              <el-menu-item index="3-1" @click="foldMenuClick">Flood</el-menu-item>-->
<!--            </el-submenu>-->
          </el-menu>
        </el-col>

        <!--地图容器-->
        <el-col :span="mapSpan" style="position: relative">
          <!-- Map container-->
          <div id="map" style="width: auto; z-index: 1"></div>


          <div  id="mapResizeButton"
                style="cursor: pointer;
                background-color: rgb(67,133,185); width: 27px; height: 98px;padding: 2px;border-radius: 3px; border: 3px solid rgb(135,206,235)">
            <img :src="zoomIn" style="width: 100%; color: white;margin-left: -1px; width: 30px;height: 30px;" title="Operation manual"  @click="openOperationMenu"/>
            <img :src="zoomOut" style="width: 100%; color: white;margin-top: 5px; margin-bottom: 5px; width: 22px;height: 22px;" @click="openDescriptionDlg"/>
            <img :src="menuResizeIcon" style="width: 100%; color: white;width: 25px;height: 25px;" @click="mapResize"/>
          </div>



          <!--图例-->
          <map-lengend
            :title="legendTitle"
            ref="ref_mapLegend"
            @colorsChanged="colorsChanged"
            :legends="selectedMapLegendsStyle"
            class="legend" id="IDLegend" @layoutupdate="legend_layoutupdate" style="display: none;"></map-lengend>


          <!--Radio Group-->
          <div  class="radio_group">

            <el-radio-group v-model="radioG_cc_prcptot" class="item_one" @change="radioGroup_change">
              <el-radio :label="item.radio_code"  v-for="item in radioData">{{item.radio_title}}</el-radio>
            </el-radio-group>

            <el-cascader class="GS_SHIDUAN" placeholder="Switch" v-model="selected_cascader" :options="cascader_options" @change="radioGroup_change" style="margin-left: 10px;"></el-cascader>

            <el-radio-group v-model="radioG_cc_prcptot_type" class="item_more" @change="radioGroup_change" v-if="cc_map_datamodel_visible()" style="margin-left: 10px;">
              <el-radio label="value">Value</el-radio>
              <el-radio label="change">Change</el-radio>
            </el-radio-group>

            <el-radio-group v-model="radioG_cc_prcptot_mm" class="item_more" @change="radioGroup_change">
              <el-radio label="mme">MME</el-radio>
              <el-radio label="mms">MMS</el-radio>
            </el-radio-group>







          </div>

<!--          <div class="css_cascader"  style="background-color: transparent;">-->
<!--            <el-cascader placeholder="Switch" v-model="selected_cascader" :options="cascader_options" @change="radioGroup_change"></el-cascader>-->
<!--          </div>-->

          <!--map layer source name  | toolabs-->
          <div class="css_map_footer" v-if="selectedRasterMapSrouce!=undefined?true:false">
            <div class="bg"></div>
            <div class="context">

              <!-- map source name-->
              {{ selectedRasterMapSrouce.toUpperCase()}}
              <a id="image-download" download="map.png"></a>
              <!--map export png-->
              <img :src="file_download"  style="float: left;margin-left: 10px; margin-top: 5px;width: 30px;height: 30px;" @click="mapExport"/>
              <img :src="file_detail"  style="float: left;margin-left: 15px; margin-top: 6px;width: 26px;height: 26px;" @click="mapDeitalView"/>



              <!--              &lt;!&ndash;map export png&ndash;&gt;-->
              <!--              <img :src="file_download"  style="float: left;margin-left: 50px; margin-top: 5px;width: 30px;height: 30px;" @click="updateStyle"/>-->
              <!--              &lt;!&ndash;map export png&ndash;&gt;-->
              <!--              <img :src="file_download"  style="float: left;margin-left: 50px; margin-top: 5px;width: 30px;height: 30px;" @click="updateStyle_2"/>-->


              <!--map legend controller-->
              <div style="float:right; width: 25px;height: 25px;margin-right: 5px;" @click="legend_layoutupdate_show">
                <img :src="legendModel==0?icon_zhankai_w:icon_shousuo_w" style="width: 100%; margin-top: 7px;" >
              </div>
            </div>

          </div>



          <!-- overlay-->
          <div id="popup" class="ol-popup">
            <el-row style="background-color: transparent; line-height: 30px; height: 30px; width: 120px;">
              <el-col :span=20 style="text-align: left;"><div style="padding-right: 20px;">{{
                  selectedRasterMapData=="NO DATA"?"NO DATA":parseFloat(selectedRasterMapData).toFixed(2)
                }}</div></el-col>
              <el-col :span=4 style="text-align: right;">
                <a href="#" id="popup-closer" class="ol-popup-closer" style="font-size: 17px;"></a>
              </el-col>
            </el-row>
          </div>


        </el-col>



      </el-row>
    </el-main>


    <el-dialog
      title="标题占位符-"
      :visible.sync="descriptionDlgVisible"
      width="60%"
      :before-close="closeDescriptionDlg">
      <div style="text-align: left;width: 100%; height: 600px;" >
        此部分放置系统说明文档
      </div>
    </el-dialog>


  </el-container>
</template>

<script>

import  ihMap  from "@/components/map/IHMap";
import  ihVerticalTabs from "@/components/widgets/IHVerticalTabs";
import  ihSignalVerticalTabs from "@/components/widgets/IHSignalVerticalTabs";
import  mapLengend from "@/view/BSD/components/MapLengend";


import 'ol/ol.css'
import {toSize} from 'ol/size';
import {menus_env,menus_exposure,menus_risk,radioGroupData,cascaderData,radioGroupData_V2} from "./BSDConfig"

import {IHMapUtils} from "../../components/map/common/IHMapUtils"


import {TDM_LAYER_CVA_C,TDM_LAYER_IBO_C,TDM_LAYER_EVA_C} from "../../components/map/common/constant"
import Overlay from 'ol/Overlay';
import {Vector as VectorLayer} from "ol/layer";
import {Vector as VectorSource} from "ol/source";
import GeoJSON from "ol/format/GeoJSON";


//Init Icon Params
let menuresizeicon_min =  require( '../../assets/icons/menu_shousuo_w.png');
let menuresizeicon_max =  require( '../../assets/icons/menu_zhankai_w.png');
let icon_zhankai_w =  require( '../../assets/icons/icon_zhankai_w.png');
let icon_shousuo_w =  require( '../../assets/icons/icon_shousuo_w.png');
let bsd_logo =  require( '../../../src/assets/icons/earth.png');
let file_download =  require( '../../assets/icons/download.png');
let file_detail =  require( '../../assets/icons/查看详情.png');

let bunMenuIcon =  require( '../../assets/imgs/bunMenu.png');
let menuresizeicon_description =  require( '../../assets/icons/description.png');
import BSDConfigLegendTitle from "./BSDConfigLegendTitle_CC"

import AppConfig from "./AppConfig";
import {geoserver,geoserver_local,geoserver_local_tiff,geoserver_basic} from "./GEOConfig"
import NavHeader from "./components/NavHeader";
import {reverseMapLegend} from "./mapTools";
import {api_bnu_getLayerLegends ,api_bnu_docDownloadTimes} from "@/api";


let mapZoomIn =  require( '../../assets/icons/加号.png');
let mapZoomOut =  require( '../../assets/icons/减号.png');
export default {
  name: "BSDMap",
  components:{ihMap,ihVerticalTabs,ihSignalVerticalTabs,mapLengend,NavHeader},
  data(){
    return {
      zoomIn:mapZoomIn,
      zoomOut:mapZoomOut,

      activeIndex: 'cc',
      menuSpan:0,
      mapSpan:24,
      menu_width:null,
      content_height:null,
      menuResizeIcon: menuresizeicon_max,
      logo: bsd_logo,
      //菜单配置
      mTabs:[],
      //地图相关的
      map:null,
      vector_layer:null,
      // geoserver:"http://218.241.129.181:8010/geoserver/DZZH/wms",
      // geoserver_local:"http://47.104.62.144:8080/geoserver/BSD/wms",
      // geoserver_local_tiff:"http://47.104.62.144:8080/geoserver/BNU_TIF/wms",
      // geoserver_basic:"http://47.104.62.144:8080/geoserver/",
      geoserver:geoserver,
      geoserver_local:geoserver_local,
      geoserver_local_tiff:geoserver_local_tiff,
      geoserver_basic:geoserver_basic,
      //
      lastClicedMenuItem:"cc_prcptot_mean",
      lastClicedMenuItemGroup:"cc_precipitation",
      mapUtils:null,
      //Radio Group Data
      radioData:undefined,
      radioG_cc_prcptot:"ann",
      //Cascader
      default_activemenu_cc:'cc_tmean_mean',
      selected_cascader:["2000_s0"],
      cascader_options:cascaderData["cc_prcptor"],
      radioG_cc_prcptot_type:"value",
      radioG_cc_prcptot_mm:"mme",
      selectedRasterMapSrouce:undefined,
      //legend
      legendModel:0,
      icon_zhankai_w,
      icon_shousuo_w,
      file_download,

      //overlay
      defaultMapOverlay:undefined,
      selectedRasterMapData:undefined,
      selectedMapLegendsStyle:undefined,
      //
      loginUser:undefined,
      file_detail,
      basicOceanLayer:undefined,
      descriptionDlgVisible:false,
      bunMenuIcon,menuresizeicon_description,
      legendTitle:"Map Lengend"
    }
  },
  methods:{
    openOperationMenu(){
      window.open(AppConfig.minio_server+"/bun/Manual%20for%20the%20use%20of%20the%20global%20typical%20disaster%20risk%20digital%20mapping%20platform.docx","_blank");
    },
    /**
     * 打开属性对话框
     * */
    openDescriptionDlg(){
      this.descriptionDlgVisible = true;
    },

    closeDescriptionDlg(){
      this.descriptionDlgVisible = false;
    },

    /**
     *
     * */
    colorsChanged(colorGroups){

      // let deepObj = JSON.parse(JSON.stringify(colorGroups));
      // let legend_data = new Array();
      // deepObj.forEach(item=>{
      //   let item_color = item.color;
      //   console.log("item.color = ",item_color);
      //   if(item_color!=undefined && item_color!=null){
      //     legend_data.push(item);
      //   }
      // });
      // console.log("legend_data = ",legend_data);

      this.selectedMapLegendsStyle = colorGroups;
      this.dynamicLodingWMSLayer(false);
    },

    /**
     *更新地图图例
     * */
    updateMapLengends(layer_code,wms_ws){

      wms_ws = wms_ws.toLowerCase();
      let legends_params_layercode = layer_code;
      let legends_params_layercodes = legends_params_layercode.split(":");
      legends_params_layercode = legends_params_layercodes[legends_params_layercodes.length-1];
      let legends_params = {
        layerName:legends_params_layercode,
        workspace:wms_ws};
      console.log("api_bnu_getLayerLegends::prams = ",legends_params);
      api_bnu_getLayerLegends(legends_params).then(res=>{
        console.log("api_bnu_getLayerLegends:: data = ",res.data);
        let res_data = res.data;
        if(res_data==undefined||res_data.length==0){
          this.$message.error("Style DATA UNDEFINED");
        }
        else {
          let res_data_data = res_data.data;
          let selectedSLDFile = JSON.parse(res_data_data);
          console.log("obj_resData.data = ",selectedSLDFile);
          this.selectedMapLegendsStyle = reverseMapLegend(selectedSLDFile);
          if(this.legendModel==1){
            this.$refs.ref_mapLegend.updateHeight();
          }
        }
      })
    },


    updateStyle(){
      this.map.getLayers().forEach(function (layer) {
        const layer_name = layer.name;
        console.log("layer_name = ",layer_name);
        if(layer_name=="Temperature_Mean:cc_tmean_ann_mean_2000s_s0_value_mme_global"){
          console.log("layer finded");
          layer.getSource().updateParams({'STYLES': "Temperature_Mean_RT_MEAN"});
        }
      })
    },
    updateStyle_2(){
      this.map.getLayers().forEach(function (layer) {
        const layer_name = layer.name;
        console.log("layer_name = ",layer_name);
        if(layer_name=="Temperature_Mean:cc_tmean_ann_mean_2000s_s0_value_mme_global"){
          console.log("layer finded");
          layer.getSource().updateParams({'STYLES': "Temperature_Mean_RT_MEAN_V2"});
        }
      })
    },

    switchFeedback(){
      let userData = this.$appStorage.getUserData();
      if(userData==undefined){
        this.$router.push({path:'/BNUMap/Login'})
      }else {
        this.$router.push({path:'/BNUMap/Feedback'})
      }
    },

    Login(){
      let userData = this.$appStorage.getUserMailbox();
      if(userData==undefined){
        this.$router.push({path:'/BNUMap/Login'})
      }else {
        alert(userData);
      }
    },

    handleSelect(key, keyPath) {
      this.activeIndex = key;
      //console.log("key = ",key,"&activeIndex =",this.activeIndex);
      if(key =="env")
      {
        //this.mTabs = menus_env;
      }
      else if(key=="risk") {
        //this.mTabs = menus_risk;
      }

      let rPath = "/BNUMap/"+key;
      this.$router.push({path:rPath})
    },

    menuClicked:function (item) {
      console.log("menu clicked = ",item);
    },

    //init the map container
    initMap:function ()
    {
      this.map = this.$olMapUtils.init({map:document.getElementById("map"),center:[90.70313,17.92969],initZoom:1,geoserver:this.geoserver_local})
    },

    initLayout(){
      const screen_height = document.body.clientHeight;
      const page_header = 60;
      const content_height = screen_height -  page_header;
      document.getElementById("root_container").style.height = document.body.clientHeight+"px";
      document.getElementById("router_view").style.height = document.body.clientHeight - 60+"px";
      document.getElementById("map").style.height = document.body.clientHeight - 60+"px";
      document.getElementById("menu_container").style.height =content_height+"px";

      this.menu_width = document.getElementById("menu_container").clientWidth;
      document.getElementById("climateMenu").style.width = this.menu_width+"px";
      document.getElementById("ChangeRisksMenus").style.width = this.menu_width+"px";
      this.content_height = document.body.clientHeight - 60;

      document.getElementById("mapResizeButton").style.top ="5px";
      document.getElementById("mapResizeButton").style.marginLeft ="5px";
    },

    mapResize(){
      if(this.menuSpan==3) {
        this.menuSpan = 0;
        this.mapSpan = 24;
        this.map.setSize(new toSize([document.body.clientWidth ,this.content_height]));
        this.menuResizeIcon = menuresizeicon_max;
      } else {
        this.menuSpan = 3;
        this.mapSpan = 21;
        this.map.setSize(new toSize([(document.body.clientWidth - this.menu_width),this.content_height]));
        this.menuResizeIcon = menuresizeicon_min;
      }
    },

    handleOpen(){},
    handleClose(){},

    //折叠菜单点击事件
    foldMenuClick(item) {
      const menuIndex = item.index;
      const menuGroup = item.$attrs.menuGroup;
      console.log("menuIndex = ",menuIndex," &menuGroup = ",menuGroup);
      this.doFoldMenuClick(menuIndex,menuGroup);
    },

    doFoldMenuClick(menuIndex,menuGroup){
      this.lastClicedMenuItem = menuIndex;
      console.log("clickedMenu = ",menuIndex);
      let routerPath = this.$route.path;
      let pathAry = routerPath.split("\/");
      let last_router_path = pathAry[pathAry.length-1];
      if(last_router_path=="cc")
      {
        let menu_1 = menuIndex.split("_")[0];
        let menu_2 = menuIndex.split("_")[1];
        let menu_3 = menuIndex.split("_")[2];
        console.log("menutype = ",menu_1," &subMenu = ",menu_2," &subMenu = ",menu_3);
      }

      //更新年份配置数据
      if(this.lastClicedMenuItem=="cc_prcptot_mean" || this.lastClicedMenuItem=="cc_prcptot_var" || this.lastClicedMenuItem=="cc_prcptot_ext"){
        this.cascader_options = cascaderData["cc_prcptor"];
      }
      else if(this.lastClicedMenuItem=="cc_tmean_mean" || this.lastClicedMenuItem=="cc_tstd_var" || this.lastClicedMenuItem=="cc_txx_ext"){
        this.cascader_options = cascaderData["cc_temprature"];
      }
      else if(this.lastClicedMenuItem=="cc_sfcwind_mean" || this.lastClicedMenuItem=="cc_sfcwind_var" || this.lastClicedMenuItem=="cc_sfcwindmax_ext"){
        this.cascader_options = cascaderData["cc_wind"];
      }
      else {
        this.$message.warning("Cascader_options update fail && this.lastClicedMenuItem = ",this.lastClicedMenuItem);
      }
      console.log("mGroup = ",menuGroup," &last mGroup = ",this.lastClicedMenuItemGroup);
      //更新 selected_cascader
      if(menuGroup!=this.lastClicedMenuItemGroup){
        let _cascader_ary = new Array();
        _cascader_ary.push(this.cascader_options[0].value);
        this.selected_cascader = _cascader_ary;
      }

      this.radioG_MapTime_updateConfig();
      this.radioGroup_change();

      this.lastClicedMenuItemGroup =menuGroup;
    },


    radioGroup_change() {
      //地图数据模型可见性控制住
      this.cc_map_datamodel_visible();
      //Raster Layer
      this.dynamicLodingWMSLayer();
    },

    /**
     * 解析需要加载的图层
     * */
    parseLayerCode(){
      let menu_1 = this.lastClicedMenuItem.split("_")[0];
      let menu_2 = this.lastClicedMenuItem.split("_")[1];
      let menu_3 = this.lastClicedMenuItem.split("_")[2];
      let wms_ws,layerCode = undefined;

      if(menu_1=="cc"){
        if(menu_2=="tmean"||menu_2=="tstd"||menu_2=="txx"){
          wms_ws = "Temperature";
        }else if(menu_2=="sfcwind"||menu_2=="sfcwindmax"){
          wms_ws = "Wind";
        }else {
          wms_ws = "Precipitation";
        }
      }

      if(menu_3=="mean"){
        wms_ws +="_Mean";
      }else if(menu_3=="var"){
        wms_ws +="_Variability";
      }else if(menu_3=="ext"){
        wms_ws +="_Extremes";
      }
      const selected_cascader_value = this.selected_cascader[this.selected_cascader.length-1];
      ///climate change action
      if(this.lastClicedMenuItem=="cc_prcptot_ext" || this.lastClicedMenuItem=="cc_txx_ext") {
        layerCode = wms_ws+":"+menu_1+"_" +this.radioG_cc_prcptot+"_ann_"+menu_3+"_"+selected_cascader_value;
        if(selected_cascader_value=="2000_s0" || selected_cascader_value=="2000s_s0"){//如果是Baseline
          layerCode = layerCode +"_value_"+this.radioG_cc_prcptot_mm+"_global";
        }else {
          layerCode = layerCode +"_"+this.radioG_cc_prcptot_type+"_"+this.radioG_cc_prcptot_mm+"_global";
        }
      }
      else{
        layerCode = wms_ws+":"+menu_1+"_"+menu_2 +"_" +this.radioG_cc_prcptot+"_"+menu_3+"_"+selected_cascader_value;
        if(selected_cascader_value=="2000_s0" || selected_cascader_value=="2000s_s0"){//如果是Baseline
          layerCode = layerCode +"_value_"+this.radioG_cc_prcptot_mm+"_global";
        }else {
          layerCode = layerCode +"_"+this.radioG_cc_prcptot_type+"_"+this.radioG_cc_prcptot_mm+"_global";
        }
      }
      return layerCode;
    },

    //加载图层
    dynamicLodingWMSLayer(needUpdateLegends=true){
      if(this.defaultMapOverlay){
        this.defaultMapOverlay.setPosition(undefined);
      }

      console.log(" ");
      let menu_1 = this.lastClicedMenuItem.split("_")[0];
      let menu_2 = this.lastClicedMenuItem.split("_")[1];
      let menu_3 = this.lastClicedMenuItem.split("_")[2];
      console.log("menutype = ",menu_1," &subMenu = ",menu_2," &subMenu = ",menu_3);
      console.log("radioG_cc_prcptot_type = ",this.radioG_cc_prcptot_type);
      console.log("radioG_cc_prcptot_mm = ",this.radioG_cc_prcptot_mm);
      console.log("selected_cascader = ",this.selected_cascader);
      console.log("this.radioG_cc_prcptot = ",this.radioG_cc_prcptot);

      let wms_ws,layerCode = undefined;
      //设置工作空间
      if(menu_1=="cc"){
        wms_ws = "Precipitation";
        if(menu_2=="tmean"||menu_2=="tstd"||menu_2=="txx"){
          wms_ws = "Temperature";
        }else if(menu_2=="sfcwind"||menu_2=="sfcwindmax"){
          wms_ws = "Wind";
        }
      }

      if(menu_3=="mean"){
        wms_ws +="_Mean";
      }else if(menu_3=="var"){
        wms_ws +="_Variability";
      }else if(menu_3=="ext"){
        wms_ws +="_Extremes";
      }


      const selected_cascader_value = this.selected_cascader[this.selected_cascader.length-1];
      console.log("selected_cascader_value = ",selected_cascader_value);

      ///climate change action
      if(this.lastClicedMenuItem=="cc_prcptot_ext" || this.lastClicedMenuItem=="cc_txx_ext")
      {          //cc_r10mm_ann_ext_2030s_rcp26_value_mme_global
        console.log("Layer code parseModel:: 1")
        layerCode = wms_ws+":"+menu_1+"_" +this.radioG_cc_prcptot+"_ann_"+menu_3+"_"+selected_cascader_value;
        if(selected_cascader_value=="2000_s0" || selected_cascader_value=="2000s_s0"){//如果是Baseline
          layerCode = layerCode +"_value_"+this.radioG_cc_prcptot_mm+"_global";
        }else {
          layerCode = layerCode +"_"+this.radioG_cc_prcptot_type+"_"+this.radioG_cc_prcptot_mm+"_global";
        }
      }
      else{
        console.log("Layer code parseModel:: 3")
        layerCode = wms_ws+":"+menu_1+"_"+menu_2 +"_" +this.radioG_cc_prcptot+"_"+menu_3+"_"+selected_cascader_value;
        if(selected_cascader_value=="2000_s0" || selected_cascader_value=="2000s_s0"){//如果是Baseline
          layerCode = layerCode +"_value_"+this.radioG_cc_prcptot_mm+"_global";
        }else {
          layerCode = layerCode +"_"+this.radioG_cc_prcptot_type+"_"+this.radioG_cc_prcptot_mm+"_global";
        }
      }

      //针对每种特殊情况的处理
      console.log("dynamicLodingWMSLayer::layerCode = ",layerCode);


      // //remove last layer
      // let layers = this.map.getLayers();
      // let layer_lenght = layers.getLength();
      // let rasterLayer = undefined;
      // for(let i=0;i<layer_lenght;i++){
      //   let item = layers.item(i);
      //   let item_name = item.name;
      //   if(item_name!=undefined){
      //     let indexofbsd = item_name.indexOf("BSD");
      //     //console.log("index = ",i," &layer = ",item,"&item_name = ",item_name," &indexofbsd = ",indexofbsd);
      //     if(indexofbsd<0){
      //       rasterLayer = item;
      //       break;
      //     }
      //   }
      // }
      //
      // if(rasterLayer!=undefined){
      //   console.log("rasterlayer != undefined && remove it");
      //   this.map.removeLayer(rasterLayer);
      // }

      //remove the previous raster layer
      if(this.selectedRasterMapLayer!=undefined){
        this.map.removeLayer(this.selectedRasterMapLayer);
        this.selectedRasterMapLayer = undefined;
      }



      //add new layer
      let tifflayer_accessurl = this.readGeoTiffAccessUrl(wms_ws);
      this.selectedRasterMapSrouce = layerCode.split(":")[1];

      let layerSytleColorGroups = undefined;
      if(needUpdateLegends){
        console.log("默认样式");
        this.updateMapLengends(layerCode,wms_ws);
      }else {
        console.log("自定义样式");
        let styleData= this.$olMapUtils.colorGroupReverse_NODATA_BLACK(this.selectedMapLegendsStyle);
        let layerSytleColorGroups =this.$olMapUtils.parseSLDBodyWithType(this.$x2js,layerCode, styleData,"RAMP");
        console.log("layerSytleColorGroups = ",layerSytleColorGroups);
      }

      this.selectedRasterMapLayer =  this.$olMapUtils.addWMSLayer({
        defaultStyles:layerSytleColorGroups,
        layerName:layerCode,
        layerCode:layerCode,
        visible:true,geoServer:tifflayer_accessurl,zIndex:0});
      this.addTDM_LAYER_EVA_C();

      /**
       * 更新ocean layer 颜色
       * */
      this.updateOceanMapLayer();

      // let _this = this;
      // setTimeout(function (){
      //   if(_this.legendModel==1){
      //     _this.$refs.ref_mapLegend.updateHeight();
      //   }
      // },300);

      //
      this.updateMapLegendTitle();
    },

    //更新地图图例
    updateMapLegendTitle(){
      let current_layer_code = this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
      let title = BSDConfigLegendTitle[current_layer_code];
      if(title==undefined){
        current_layer_code = current_layer_code.replace("GLOBAL","GOBAL").toUpperCase();
        title = BSDConfigLegendTitle[current_layer_code];
      }
      this.legendTitle =title;
    },

    /**
     * 地图数据模式加载 - Change & Value
     * */
    cc_map_datamodel_visible(){
      let selected_cascader_laster = this.selected_cascader[this.selected_cascader.length-1];
      if(selected_cascader_laster=="2000_s0" || selected_cascader_laster=="2000s_s0"){
        return false;
      }
      return true;
    },

    /**
     * Annual && Winter && Summer 配置参数更新
     * */
    radioG_MapTime_updateConfig(){
      console.log("radioG_MapTime_updateConfig::lastClicedMenuItem = ",this.lastClicedMenuItem);
      let selectedRadioGroupData =  radioGroupData_V2[this.lastClicedMenuItem];
      if(selectedRadioGroupData!=undefined && selectedRadioGroupData.length>0) {
        this.radioData = selectedRadioGroupData;
        let selectedRadioGroupData_default = selectedRadioGroupData[0];
        this.radioG_cc_prcptot = selectedRadioGroupData_default.radio_code;
      }
      else {
        console.log("selectedRadioGroupData = null");
      }
    },

    /**
     *
     **/
    readGeoTiffAccessUrl(workspace){
      workspace = workspace.toLowerCase();
      return this.geoserver_basic+workspace+"/wms";
    },

    /**
     * 级联菜单 2020年9月28日16:09:41
     * */
    cascader_changed(value){
      console.log(value);
    },

    /**
     *
     * */
    mapSourceLayout(){
      if(this.selectedRasterMapSrouce==undefined){
        document.getElementById("IDLegend").style.bottom = "40px";
      } else {
        document.getElementById("IDLegend").style.bottom = "40px";
      }
    },

    /**
     * 根据路由路径打开默认的地图图层
     * */
    openDefaultMapSource(){
      // let routerPath = this.$route.path;
      // let pathAry = routerPath.split("\/");
      // let last_router_path = pathAry[pathAry.length-1];
      // if(last_router_path=="cc")//气候的默认图层
      // {
      //   //默认打开一个菜单
      //   this.$refs.el_menu_cc.open('temperature');
      //   //默认加载一个地图图层
      //   this.foldMenuClick({
      //     index:"cc_tmean_mean",
      //     $attrs:{
      //       menuGroup:"cc_temprature"
      //     }
      //   })
      // }
      let sm = this.$route.query.sm
      if(sm==undefined){
        sm = "cc_tmean_mean";
      }
      this.default_activemenu_cc = sm;
      this.selected_cascader =["2000_s0"];

      if(sm=="cc_tmean_mean"){
        this.$refs.el_menu_cc.open('temperature');
        this.foldMenuClick({
          index:"cc_tmean_mean",
          $attrs:{
            menuGroup:"cc_temprature"
          }
        })
      }else if(sm=="cc_prcptot_mean"){
        this.$refs.el_menu_cc.open('precipitation');
        this.foldMenuClick({
          index:"cc_prcptot_mean",
          $attrs:{
            menuGroup:"cc_precipitation"
          }
        })
      }else if(sm=="cc_sfcwind_mean"){
        this.$refs.el_menu_cc.open('sfcwind');
        this.foldMenuClick({
          index:"cc_sfcwind_mean",
          $attrs:{
            menuGroup:"cc_wind"
          }
        })
      }


    },


    legend_layoutupdate(data){
      let obj = document.getElementById("IDLegend");
      let obj_height = obj.style.height;
      obj.style.bottom = (0-parseInt(data))-50 +"px";
    },

    legend_layoutupdate_show(){
      let obj = document.getElementById("IDLegend");
      obj.style.bottom = "40px";

      if(this.legendModel==0){
        this.legendModel=1;
        document.getElementById("IDLegend").style.display = 'block';
      }else {
        this.legendModel = 0;
        document.getElementById("IDLegend").style.display = 'none';
      }

      if(this.legendModel==1){
        this.$refs.ref_mapLegend.updateHeight();
      }
    },




    /**
     * @author zhangchengguo
     * @description 导出地图文件
     * */
    doMapExport(){
      let _map = this.map;
      this.map.once('rendercomplete', function () {
        var mapCanvas = document.createElement('canvas');
        var size =_map.getSize();
        mapCanvas.width = size[0];
        mapCanvas.height = size[1];
        var mapContext = mapCanvas.getContext('2d');
        Array.prototype.forEach.call(
          document.querySelectorAll('.ol-layer canvas'),
          function (canvas) {
            if (canvas.width > 0) {
              var opacity = canvas.parentNode.style.opacity;
              mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
              var transform = canvas.style.transform;
              // Get the transform parameters from the style's transform matrix
              var matrix = transform
                .match(/^matrix\(([^\(]*)\)$/)[1]
                .split(',')
                .map(Number);
              // Apply the transform to the export map context
              CanvasRenderingContext2D.prototype.setTransform.apply(
                mapContext,
                matrix
              );
              mapContext.drawImage(canvas, 0, 0);
            }
          }
        );
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(mapCanvas.msToBlob(), 'map.png');
        } else {
          var link = document.getElementById('image-download');
          link.href = mapCanvas.toDataURL();
          link.click();
        }
      });
      _map.renderSync();
    },

    mapExport(){
      console.log("BSDMapRISK::mapExport");
      let _this = this;
      api_bnu_docDownloadTimes({path:this.selectedRasterMapSrouce.toLowerCase()}).then(res=>{
        let rData = res.data;
        console.log("rData = ",rData);
        _this.doMapExport();
      })
    },




    /**
     * @description 地图详情预览
     * */
    mapDeitalView(){
      //window.open("https://cbcdn.cafewallet.cn/docfile/FileDownlaodTtest_20201127.docx","_blank");
      let basickPath = AppConfig.minio_server+"/bun/"
      switch (this.lastClicedMenuItem){
        case "cc_tmean_mean":
          basickPath = basickPath +"climate_change/Temperature/Mean/";
          break;
        case "cc_tstd_var":
          basickPath = basickPath +"climate_change/Temperature/Variability/";
          break;
        case "cc_txx_ext":
          basickPath = basickPath +"climate_change/Temperature/Extremes/";
          break;

        //precipition
        case "cc_prcptot_mean":
          basickPath = basickPath +"climate_change/Precipitation/Mean/";
            if(this.radioG_cc_prcptot=="ann"){
              basickPath +="Annual/";
            }else if(this.radioG_cc_prcptot=="djf"){
              basickPath +="Winter/";
            }else if(this.radioG_cc_prcptot=="jja"){
              basickPath +="Summer/";
            }
          break;
        case "cc_prcptot_var":
          basickPath = basickPath +"climate_change/Precipitation/Variability/";
            if(this.radioG_cc_prcptot=="ann"){
              basickPath +="Annual/";
            }else if(this.radioG_cc_prcptot=="djf"){
              basickPath +="Winter/";
            }else if(this.radioG_cc_prcptot=="jja"){
              basickPath +="Summer/";
            }
          break;
        case  "cc_prcptot_ext":
          basickPath = basickPath +"climate_change/Precipitation/Extremes/";
          if(this.radioG_cc_prcptot=="r10mm"){
            basickPath +="R10MM/";
          }else if(this.radioG_cc_prcptot=="rx1day"){
            basickPath +="RX1D/";
          }else if(this.radioG_cc_prcptot=="rx5day"){
            basickPath +="RX5D/";
          }
          break

        //Wind speed
        case "cc_sfcwind_mean":
          basickPath = basickPath +"climate_change/Wind/Mean/";
          break;
        case "cc_sfcwind_var":
          basickPath = basickPath +"climate_change/Wind/Variability/";
          break;
        case "cc_sfcwindmax_ext":
          basickPath = basickPath +"climate_change/Wind/Extremes/";
          break;

      }
      let file = basickPath +this.selectedRasterMapSrouce.toUpperCase()+".docx";
      window.open(file,"_blank");

    },


    /**
     * 矢量英文注记
     * */
    addTDM_LAYER_EVA_C(){

      let  selectedLayer = undefined;
      const layers = this.map.getLayers();
      const layer_lenght = layers.getLength();

      for(let i=0;i<layer_lenght;i++){
        const item = layers.item(i);
        const item_name = item.name;
        //console.log("index = ",i," &layer = ",item,"&item_name = ",item_name);
        if(item_name!=undefined && item_name=="BSD:TDM_LAYER_EVA_C") {
          selectedLayer = item;
        }
      }

      if(selectedLayer==undefined){
        console.log("add new  TDM_LAYER_EVA_C");
        TDM_LAYER_EVA_C.setZIndex(500);
        this.map.addLayer(TDM_LAYER_EVA_C);
      }


    },

    getPath(to,from){
      this.activeIndex = this.$route.path.substring(this.$route.path.lastIndexOf("/")+1);

      let sm = this.$route.query.sm;
      this.menuClicked(sm);


    },



    /**
     * 查询地图点击查询值
     * */
    readMapPoint(evt){
      this.defaultMapOverlay.setPosition(undefined);
      //校验点是否有效
      let view = this.map.getView();
      let viewResolution = view.getResolution();
      let source =this.basicOceanLayer.getSource();
      let url = source.getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        view.getProjection(),
        {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});
      let _this = this;
      console.log("readMapPoint::checkQueryPointValid && url = ",url);
      this.axios.get(url).then((response)=>{
        console.log("checkQueryPointValid::response.data = ",response.data);
        const selectedFeatures =response.data.features;
        if(selectedFeatures.length==0){
          console.log("Click Raster Layer && read Raster value");
          _this.readSelectedPointData(evt);
        }else{
          console.log("click At Ocean Layer && do nothing");
        }
      })
    },


    readSelectedPointData(evt){
      var view = this.map.getView();
      var viewResolution = view.getResolution();
      var source =this.selectedRasterMapLayer.getSource();
      var url = source.getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        view.getProjection(),
        {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});


      console.log("Query Raster Point Value && url =  ",url," && this.selectedRasterMapLayer = ",this.selectedRasterMapLayer);
      this.axios.get(url).then((response)=>{
        console.log("response.data = ",response.data);
        const selectedFeatures =response.data.features;
        if(selectedFeatures.length>0) {
          const selectedFeature = selectedFeatures[0];
          const selectedFeature_properties = selectedFeature.properties;
          this.selectedRasterMapData = selectedFeature_properties.GRAY_INDEX;
          console.log("this.selectedRasterMapData = ",this.selectedRasterMapData);

          if(this.selectedRasterMapData==null){
            this.selectedRasterMapData = "NO DATA";
            this.defaultMapOverlay.setPosition(evt.coordinate);
            return;
          }

          //处理科学基数
          if(this.selectedRasterMapData!=undefined){
            console.log("处理科学基数");
            let raster_rate = this.getRasterValueRate();
            console.log("raster_rate = ",raster_rate);
            this.selectedRasterMapData = parseFloat(this.selectedRasterMapData)*this.getRasterValueRate();
          }

          if((this.selectedRasterMapData && this.selectedRasterMapData !=null) || parseFloat(this.selectedRasterMapData)!=0){
            if(parseFloat(this.selectedRasterMapData)<0){
              let selectedRasterMapData_str = this.selectedRasterMapData+" ";
              if(selectedRasterMapData_str.indexOf("e+")>-1){
                console.log("negitive value && value is too small");
                this.selectedRasterMapData = "NO DATA";
              }
            }
            this.defaultMapOverlay.setPosition(evt.coordinate);
          } else {
            this.defaultMapOverlay.setPosition(undefined);
          }
        }
      })
    },

    getRasterValueRate(){
      let current_layer_code = this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
      let rate = undefined;
      let title = BSDConfigLegendTitle[current_layer_code];
      if(title!=undefined){
        let title_seg = title.split("#");
        title_seg.forEach(item=>{
          if(item.indexOf("^")>-1){
            rate = item.split("^")[1]
          }
        })
      }
      let raster_value_rate = 1;
      if(rate!=undefined){
        for(let i=0;i<rate;i++){
          raster_value_rate = raster_value_rate*(0.1);
        }
      }
      return raster_value_rate;
    },


    initMapOverlay(){
      if(this.map && this.defaultMapOverlay==undefined){
        var container = document.getElementById('popup');
        var closer = document.getElementById('popup-closer');
        var overlay = new Overlay({
          element: container,
          autoPan: true,
          autoPanAnimation: {
            duration: 250,
          },
        });
        closer.onclick = function () {
          overlay.setPosition(undefined);
          closer.blur();
          return false;
        };
        this.map.addOverlay(overlay);
        this.defaultMapOverlay = overlay;
      }
    },


    loginOut() {
      this.$confirm('Do you want to log out?', 'Prompt', {
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        //清除缓存，修改登录状态
        this.$appStorage.userLogout();
        this.loginUser = this.$appStorage.getUserMailbox();
      })
    },


    /**
     * @author zhangchengguo at 2020年12月07日22:36:22
     * @description 更新海洋背景
     * */
    updateOceanMapLayer(){
      let selected_cascader_laster = this.selected_cascader[0];
      this.$olMapUtils.updateOceanMapLayer(this.map,selected_cascader_laster.toLowerCase());
    },


    readActiveTag(sm){
      let _activeTab=0;
      switch (sm) {
        case "world_political_map":
          _activeTab=0;
          break;
        case "global_satellite_image":
          _activeTab=1;
          break;
        case "global_elevation":
          _activeTab=2;
          break;
        case "global_climate_zones":
          _activeTab=3;
          break;
        case "global_soil":
          _activeTab=4;
          break;
      }
      return _activeTab;
    },


  },
  watch: {
    $route(to,from){

      console.log(from.path);//从哪来
      console.log(to.path);//到哪去
      let sm = this.$route.query.sm;
      console.log("watch::$route && sm = ",sm);
      this.default_activemenu_cc = sm;
      switch (sm){
        case "cc_tmean_mean":
          this.doFoldMenuClick(sm,"cc_temprature");
          break;
        case "cc_prcptot_mean":
          this.doFoldMenuClick(sm,"cc_precipitation");
          break;
        case "cc_sfcwind_mean":
          this.doFoldMenuClick(sm,"cc_wind");
          break;
      }
    }
  },
  created() {
    let sm = this.$route.query.sm
    this.lastClicedMenuItem= sm;
    //this.activeTab = this.readActiveTag(sm);
    //this.lastClicedMenuItem = "world_political_map";

  },
  mounted()
  {
    this.initLayout();
    this.initMap();
    this.selected_cascader =["2000_s0"];
    //this.$olMapUtils.addWMSLayer({layerName:"ocean_bg",layerCode:"BSD:ocean_bg_4326",visible:true});
    let tifflayer_accessurl = this.readGeoTiffAccessUrl("Precipitation_Variability");

    //
    // this.$olMapUtils.addWMSLayer({
    //   layerName:"Precipitation_Variability:cc_prcptot_ann_var_2030s_rcp26_change_mme_global_20062808",
    //   layerCode:"Precipitation_Variability:cc_prcptot_ann_var_2030s_rcp26_change_mme_global_20062808",
    //   visible:true,geoServer:tifflayer_accessurl,zIndex:0});


    // map layers above the geotiff layer
    //this.$olMapUtils.addWMSLayer({layerName:"country",layerCode:"BSD:country_project",visible:true,zIndex:10});



    //加载矢量图层
    // map layers above the geotiff layer
    this.basicOceanLayer = this.$olMapUtils.addWMSLayer({layerName:"BSD:ocean", layerCode:"BSD:ocean", visible:true,zIndex:9,});
    this.$olMapUtils.addWMSLayer({layerName:"BSD:country",layerCode:"BSD:country_project",visible:true,zIndex:10});
    this.$olMapUtils.addWMSLayer({layerCode:"BSD:geogrid_4326",zIndex:12});
    this.$olMapUtils.addWMSLayer({layerCode:"BSD:military_border",zIndex:13});
    this.$olMapUtils.addWMSLayer({layerCode:"BSD:undefine_country_border",zIndex:14});


    //this.$olMapUtils.addWMSLayer({layerCode:"BSD:bsd_population_sealand_boundary_3857",geoServer:this.geoserver_local,wrapX:false,projection:"EPSG:3857"});

    //this.$olMapUtils.addWMSLayer({layerCode:"BSD:bsd_population_continent_boundary_4326",geoServer:this.geoserver_local,projection:"EPSG:4326"});
    //this.$olMapUtils



    let _this = this;
    this.map.on('click', function (event) {
      var coordinate = event.coordinate;
      //console.log("coordinate = ",coordinate);
      var _map = event.target;
      var pixel =_map.getPixelFromCoordinate(coordinate);
      //console.log("pixel = ",pixel);


      if(_this.selectedRasterMapLayer){
        _this.readMapPoint(event);
      }

    });

    //
    this.radioG_MapTime_updateConfig();

    //
    this.$watch('selectedRasterMapSrouce', function (newValue, oldValue) {//a是属性名，表示要监听的对象
      this.mapSourceLayout();
    });
    this.mapSourceLayout();
    //
    this.openDefaultMapSource();
    //
    this.initMapOverlay();
    //
    //this.legend_layoutupdate_show();

    //
    this.loginUser = this.$appStorage.getUserMailbox();
    //
    this.mapResize();


    this.legendModel = 0;
    this.legend_layoutupdate_show();
    setTimeout(function (){
      if(_this.legendModel==1){
        _this.$refs.ref_mapLegend.updateHeight();
      }
    },50)
  }


}
</script>




<style scoped lang="scss">
@import "BSDMap";
</style>



// WEBPACK FOOTER //
// src/view/BSD/BSDMap.vue